import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteService {

  private subject = new Subject<any>();
  private keyUp = new Subject<any>();
  private dataList = new Subject<any>();


  onSelectionChange(data): void {
      this.subject.next(data);
  }

  selectServiceSubscription(): Observable<any> {
      return this.subject.asObservable();
  }

  onKeyUp(data){
 
    this.keyUp.next(data);
  }

  selectKeyUpSubscription(): Observable<any> {
    return this.keyUp.asObservable();
  }

  ondataListChange(data): void {
    this.dataList.next(data);
}

   selectdataListSubscription(): Observable<any> {
    return this.dataList.asObservable();
}



 

  

  
}
